<template>
  <v-dialog :value="true" persistent max-width="500">
    <v-card>
      <v-form @submit.prevent="scheduleSMS" v-model="isFormValid" ref="form">
        <v-card-title class="text-h5">Schedule SMS</v-card-title>
        <v-card-text class="mt-7">
          <!-- Pick date -->
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :return-value.sync="date"
            transition="scale-transition"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date"
                label="Pick date"
                :rules="[requiredRule]"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu = false"> Cancel </v-btn>
              <v-btn text color="primary" @click="$refs.menu.save(date)">
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>
          <!-- Pick time -->
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="time"
            transition="scale-transition"
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="time"
                label="Pick time"
                :rules="requiredRule"
                prepend-inner-icon="mdi-clock-time-four-outline"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-time-picker v-if="menu2" v-model="time" full-width ampm-in-title>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="menu2 = false">
                Cancel
              </v-btn>
              <v-btn text color="primary" @click="$refs.menu2.save(time)">
                OK
              </v-btn></v-time-picker
            >
          </v-menu>
          <v-btn
            class="mt-2 primary white--text lowercase-text"
            block
            plain
            :loading="$store.state.loading.scheduleBtn.load"
            :disabled="$store.state.loading.scheduleBtn.disabled"
            type="submit"
          >
            Schedule message
          </v-btn>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="$emit('close')"> CLOSE</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["phoneNumbersArray", "selectedTemplateMessage", "selectedSenderId"],
  data() {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      menu: false,
      time: null,
      menu2: false,
      isFormValid: false,
      requiredRule: [(v) => !!v || "This field is required"],
    };
  },
  methods: {
    async scheduleSMS() {
      if (this.$refs.form.validate()) {
        // Form is valid, perform form submission or other actions
        const dateTimeString = `${this.date} ${this.time}`;
        const scheduledDate = new Date(dateTimeString);
        await this.$store.dispatch("send/scheduleSMS", {
          senderId: this.selectedSenderId,
          scheduledDate,
          message: this.selectedTemplateMessage,
          phoneNumbers: this.phoneNumbersArray,
        });
        this.closeDialoag();
      }
    },
    closeDialoag() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped>
.v-btn {
  text-transform: none;
}
.row-pointer {
  cursor: pointer;
  color: #2c5282;
}
.custom-card {
  /* Add your additional border radius values */
  border-radius: 10px;
}
</style>
